import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SimilarCareer {
  soc_code: string;
  occ_title: string;
  similarity: number;
}

export interface SimilarCareersResult {
  soc: string;
  similar: SimilarCareer[];
  available: boolean;
}

/**
 * Fetches semantically similar occupations via the optional pgvector AI layer.
 * Degrades gracefully: when embeddings haven't been provisioned, `available` is
 * false and `similar` is empty, so callers can hide the module entirely.
 */
export const useSimilarCareers = (soc?: string, limit = 6) => {
  return useQuery<SimilarCareersResult>({
    queryKey: ['similar-careers', soc, limit],
    enabled: !!soc,
    staleTime: 1000 * 60 * 60 * 12,
    gcTime: 1000 * 60 * 60 * 24,
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('api-similar-careers', {
        body: { soc, limit },
      });
      if (error) throw error;
      return data as SimilarCareersResult;
    },
  });
};
